import {
  MuiTelInput,
  MuiTelInputCountry,
  MuiTelInputProps,
} from 'mui-tel-input';
import React from 'react';

// Define props for the new base component
// It should accept standard MuiTelInputProps
export type PhoneInputProps = MuiTelInputProps;

export const PhoneInput: React.FC<PhoneInputProps> = ({
  value,
  onChange,
  defaultCountry = 'US', // Keep sensible defaults
  ...props // Pass rest of the props
}) => {
  return (
    <MuiTelInput
      {...props} // Spread all incoming props
      value={value || ''} // Use passed value
      onChange={onChange} // Use passed onChange
      defaultCountry={defaultCountry as MuiTelInputCountry}
      focusOnSelectCountry={true}
      forceCallingCode={true}
    />
  );
};
